import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowRight } from "react-icons/fa";
import { energyData } from "../../content/content";
import useGsapAnimations from "../../../hooks/useGsapAnimations";

const CbgLocation = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    bgImage,
    title,
    description,
    buttonText,
    statistics,
    testimonials,
    mapImage,
  } = energyData;

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    beforeChange: (_, newIndex) => setActiveIndex(newIndex),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1.5 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  useEffect(() => {
    const elements = document.querySelectorAll(
      ".fade-in, .slide-up, .title-animate, .desc-animate, .card-animation"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className="relative py-20 text-white bg-gray-900">
      <div
        className="absolute inset-0 bg-cover bg-center fade-in"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="absolute inset-0 bg-gray-800 bg-opacity-95"></div>
      </div>

      <div className="relative container mx-auto px-6 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="mt-[-170px] title-animate">
            <p className="text-green-400 font-semibold mt-20 mb-4 uppercase tracking-wide">
              Pioneers of Compressed Biogas & Renewable Energy Solutions!.
            </p>
            <h2 className="text-4xl font-bold text-white leading-tight">
              Commercial, Residential <br /> & Industrial CBG Systems!
            </h2>
          </div>

          <div className="desc-animate">
            <p className="text-gray-300 text-md mb-5 mt-[-20px] leading-relaxed">
              Today, our company stands as a leading provider of Compressed
              Biogas (CBG) solutions across North America and Europe. With
              extensive experience in the biogas industry, our sales offices and
              distribution networks ensure seamless material sourcing and supply
              chain expertise at every stage of CBG production and installation.
            </p>
            {/* <button
              onClick={() =>
                (window.location.href = "http://localhost:3000/company-profile")
              }
              className="mt-3 px-8 py-5 hover:bg-white hover:text-black bg-green-500 text-white font-semibold rounded-md shadow-lg flex items-center gap-2"
            >
              Awards & Milestones <FaArrowRight className="w-5 h-4" />
            </button> */}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mt-10 fade-in">
          {/* {mapImage && (
            <div className="relative w-full card-animation">
              <img
                src={mapImage}
                alt="Map Location"
                className="md:max-w-2xl h-auto w-screen opacity-90"
              />
            </div>
          )} */}

          {/* <div className="grid grid-cols-1 ml-2 md:ml-24 gap-8 slide-up">
            {statistics.map((stat, index) => (
              <div key={index} className="text-center">
                <h3 className="text-3xl text-start font-bold text-green-400">
                  {stat.title}{" "}
                  <span className="italic text-start text-white">
                    {stat.subtitle}
                  </span>
                </h3>
                <p className="text-gray-300 text-lg mt-2 text-start leading-relaxed">
                  {stat.description}
                </p>
                {index !== statistics.length - 1 && (
                  <div className="w-full h-px bg-gray-500 mt-6"></div>
                )}
              </div>
            ))}
          </div> */}
        </div>

        <div className="mt-5 mx-auto max-w-7xl slide-up">
          <Slider {...sliderSettings}>
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`p-6 sm:p-8 rounded-lg shadow-lg flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 ${
                  activeIndex === index ? "opacity-100" : "opacity-50"
                }`}
              >
                <div className="flex-1">
                  <p
                    className={`text-xl italic leading-relaxed ${
                      activeIndex === index ? "text-white" : "text-gray-400"
                    }`}
                  >
                    "{testimonial.quote}"
                  </p>
                  <p
                    className={`mt-4 font-semibold ${
                      activeIndex === index ? "text-white" : "text-gray-500"
                    }`}
                  >
                    {testimonial.name},{" "}
                    <span className="text-green-400">
                      {testimonial.position}
                    </span>
                  </p>
                </div>
              </div>
            ))}
          </Slider>

          {/* Indicator Dots */}
          <div className="flex justify-center mt-6 gap-2 fade-in">
            {testimonials.map((_, index) => (
              <div
                key={index}
                className={`w-8 h-2 rounded-lg transition-all duration-300 ${
                  activeIndex === index ? "bg-green-500" : "bg-gray-500"
                }`}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CbgLocation;
